import { useDataLoader } from "2g-hooks/fetch";
import { useDidUpdateEffect } from "2g-hooks";

import { DATA } from "b2b/api/paths";

export default function useRezervace({ datumOd, datumDo, stav, typZdroje }) {
  const loader = useDataLoader({
    url: DATA.rezervace(),
    method: "post",
    payload: {
      datumOd: datumOd.getTime(),
      datumDo: datumDo.getTime(),
      stav,
      typZdroje
    }
  });

  useDidUpdateEffect(() => {
    loader.load();
  }, [datumOd.getTime(), datumDo.getTime(), stav, typZdroje]);

  return loader;
}
